// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"4076bcf7","400":"666634aa","453":"c8f41ff1"}[chunkId] + ".chunk.js";
};